module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entrance-report-page"
  }, [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_entrance")) + "\n      "), (_vm.allCustomCategories.length === 0 && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openDoor()
      }
    }
  }, [_c('i', {
    staticClass: "ti-hand-open"
  }), _vm._v(_vm._s(_vm.locale.t('label_open_door')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.allCustomCategories.length > 0 && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.allCustomCategories), function(item) {
    return _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.openDoor(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-hand-open"
    }), _vm._v(_vm._s(_vm.locale.t('label_open_door')) + " " + _vm._s(item) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "entrance-report-date-row"
  }, [_c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('div', {
    staticClass: "section-top-sm section-bottom-sm"
  }, [_c('div', {
    staticClass: "scrollmenu"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_location')))]), _vm._v(" "), _vm._l((_vm.allCustomCategories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectCustomCategory(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassCustomCategory(item)
    }, [_vm._v(_vm._s(_vm.isSelectedCustomCategory(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n        ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "report-muted"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_choose_location_desc')))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button section-top-sm",
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary"
  }, [_c('div', {
    staticClass: "entrance-summary__kpis"
  }, [_c('div', {
    staticClass: "entrance-summary__kpi"
  }, [_c('div', {
    staticClass: "entrance-summary__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_entrance_total')))]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__kpi-value"
  }, [_vm._v(_vm._s(_vm.entranceSummary.totalEntrances))])]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__kpi"
  }, [_c('div', {
    staticClass: "entrance-summary__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_entrance_most_popular_time')))]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__kpi-value"
  }, [_vm._v(_vm._s(_vm.popularEntranceTime))])]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__kpi"
  }, [_c('div', {
    staticClass: "entrance-summary__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_entrance_count_then')))]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__kpi-value"
  }, [_vm._v(_vm._s(_vm.popularEntranceCount))])])]), _vm._v(" "), (!_vm.entranceSummaryLoading) ? _c('article', {
    staticClass: "entrance-summary__chart"
  }, [_c('header', {
    staticClass: "entrance-summary__chart-head"
  }, [_c('div', {
    staticClass: "entrance-summary__chart-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_entrance_by_bucket')) + " " + _vm._s(_vm.bucketLabel))]), _vm._v(" "), _c('div', {
    staticClass: "entrance-summary__chart-meta"
  }, [_vm._v(_vm._s(_vm.entranceSummary.bucketType))])]), _vm._v(" "), (_vm.timeStatsChart.length) ? _c('div', {
    staticClass: "entrance-summary__rows"
  }, _vm._l((_vm.timeStatsChart), function(item, idx) {
    return _c('div', {
      key: 'entrance-chart-' + item.timeBucket + '-' + idx,
      staticClass: "entrance-summary__row"
    }, [_c('div', {
      staticClass: "entrance-summary__label"
    }, [_vm._v(_vm._s(item.timeBucket))]), _vm._v(" "), _c('div', {
      staticClass: "entrance-summary__bar-wrap"
    }, [_c('div', {
      staticClass: "entrance-summary__bar",
      style: ({
        width: _vm.chartWidth(item.entrances, _vm.maxTimeBucketEntrances)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "entrance-summary__value"
    }, [_vm._v(_vm._s(item.entrances))])])
  }), 0) : _c('div', {
    staticClass: "entrance-summary__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_no_entrance_data_for_period')))])]) : _vm._e(), _vm._v(" "), (_vm.entranceSummaryLoading) ? _c('div', {
    staticClass: "entrance-summary__loading"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [(_vm.useProfilePictures) ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_surname")))]), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_location")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_time")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_rest_trainings")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredEntrance), function(entrance) {
    return _c('tr', [(_vm.useProfilePictures) ? _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(entrance.photoUrl != null && entrance.photoUrl.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": entrance.photoUrl
      },
      on: {
        "click": function($event) {
          return _vm.openImage(entrance.photoUrl, entrance.userId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (entrance.photoUrl == null || entrance.photoUrl.length === 0) ? _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      },
      on: {
        "click": function($event) {
          return _vm.openImage('', entrance.userId)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(entrance.firstName))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_surname')
      }
    }, [_vm._v(_vm._s(entrance.lastName))]), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_surname')
      }
    }, [_vm._v("\n              " + _vm._s(entrance.customCategory) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_time')
      }
    }, [_vm._v(_vm._s(_vm.formatDateAndTime(entrance.timestamp)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_rest_trainings')
      }
    }, [_vm._v(_vm._s(entrance.restOfTraining))])])
  }), 0)])])])]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('show-image-dialog', {
    attrs: {
      "show": _vm.showImagePreview,
      "image": _vm.imageToPreview,
      "userId": _vm.imageToPreviewUserId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ea8f8f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Entrance/Entrance.vue
// module id = 710
// module chunks = 0